import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

import {Subject} from 'rxjs';

import {CoreConfigService} from '@core/services/config.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../../../core/service';
import {TranslatePipe} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import { LoginRequest } from 'app/core/requests/LoginRequest';
import { emailRegex } from 'app/core/helpers/constants';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    TranslatePipe
  ],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  // Public
  public coreConfig: any;
  public forgotPasswordForm: FormGroup;
  private ngUnsubscribe = new Subject();
  public subdomain: string;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private _route: ActivatedRoute,
    private _router: Router,
    private translate: TranslatePipe,
    private _toastrService: ToastrService
  ) {
    this.subdomain = this._route.snapshot.params['subdomain'];
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
      }
    };
  }

  ngOnInit(): void {
    this.forgotPasswordForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailRegex)]]
    });

    // Subscribe to config changes
    this._coreConfigService.config.subscribe(config => {
      this.coreConfig = config;
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.forgotPasswordForm.controls;
  }

  /**
     * Forgot password
     */
  forgotPassword() {

    // stop here if form is invalid
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    const email: string = this.f.email.value;
    const fortgotPasswordRequest: LoginRequest = {
      userIdentifier: email,
      platformUrl: this.subdomain
    };
    this.authenticationService.forgotPassword(fortgotPasswordRequest)
      .subscribe(
        _ => {
          this.onForgotPasswordSuccess();
        },
        error => {
          this.onForgotPasswordFail(error);
        });
  }

  public onForgotPasswordSuccess() {
    this._toastrService.success(
      this.translate.transform('FORGOT_PASSWORD.SUCCESS'),
      this.translate.transform('SUCCESS'),
      {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
    );

    // redirect to login
    setTimeout(() => {
      this._router.navigate(['/' + this.subdomain + '/authentication/login']);
    }, 100);
  }

  public onForgotPasswordFail(error: any) {
    if(error && error.messages) {
      error.messages.forEach((errorItem) => {
        this._toastrService.error(
          this.translate.transform(errorItem),
          this.translate.transform('ERROR'),
          {toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000}
        );
      });
    }
  }
}
